import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\GravePlot\SearchGravePlotForController::__invoke
* @see app/Http/Controllers/GravePlot/SearchGravePlotForController.php
* @route '/api/grave-plot/{person}/for-search'
*/
const SearchGravePlotForController = (args: { person: string | number | { id: string | number } } | [person: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: SearchGravePlotForController.url(args, options),
    method: 'get',
})

SearchGravePlotForController.definition = {
    methods: ["get","head"],
    url: '/api/grave-plot/{person}/for-search',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\GravePlot\SearchGravePlotForController::__invoke
* @see app/Http/Controllers/GravePlot/SearchGravePlotForController.php
* @route '/api/grave-plot/{person}/for-search'
*/
SearchGravePlotForController.url = (args: { person: string | number | { id: string | number } } | [person: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { person: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { person: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            person: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        person: typeof args.person === 'object'
        ? args.person.id
        : args.person,
    }

    return SearchGravePlotForController.definition.url
            .replace('{person}', parsedArgs.person.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\GravePlot\SearchGravePlotForController::__invoke
* @see app/Http/Controllers/GravePlot/SearchGravePlotForController.php
* @route '/api/grave-plot/{person}/for-search'
*/
SearchGravePlotForController.get = (args: { person: string | number | { id: string | number } } | [person: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: SearchGravePlotForController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\GravePlot\SearchGravePlotForController::__invoke
* @see app/Http/Controllers/GravePlot/SearchGravePlotForController.php
* @route '/api/grave-plot/{person}/for-search'
*/
SearchGravePlotForController.head = (args: { person: string | number | { id: string | number } } | [person: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: SearchGravePlotForController.url(args, options),
    method: 'head',
})

export default SearchGravePlotForController